export default {
  phone: '8 800 777 91 67',
  offerLink: 'https://s.algoritmika.org/1rqoni6',
  mailing: 'https://algoritmika.org/mailing',
  privacy: 'https://algoritmika.org/mailing',
  currency: '₽',
}
